
<template>
  <div class="usersSignUp">
    <div class="main" v-if="userType">
        <div class="top-search">
          <div class="search-item">个体工商户名称：<div><el-select v-model="companyValue" placeholder="请选择">
                  <el-option
                  v-for="item in CompanyOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                  </el-option>
              </el-select>
              <!-- <el-input placeholder="请输入公司名称" v-model="companyValue" clearable></el-input> -->
              </div></div>
          <div class="search-item"><el-button type="primary" @click="search">搜索</el-button></div>
          <div class="search-item"><el-button type="danger" @click="reset">重置</el-button></div>
        </div>
        <div class="bottom-table">
            <el-table
              :data="signingData  "
              border
              height="676"
              style="width: 100%">
              <el-table-column
              prop="name"
              label="个体工商户名称">
              </el-table-column>
              <el-table-column
              prop="creditCode"
              label="统一社会信用代码">
              </el-table-column>
              <el-table-column
              prop="costRate"
              label="核定成本费用率">
              </el-table-column>
              <el-table-column
              prop="taxRate"
              label="含税价百分比">
              </el-table-column>
              <el-table-column
              prop="taxUpType"
              label="个税计费">
                <template slot-scope="scope">
                  <div v-if="scope.row.taxUpType == 1">按月累计</div>
                  <div v-if="scope.row.taxUpType == 2">按年累计</div>
                </template>
              </el-table-column>
              <el-table-column
              prop="addValueUpType"
              label="增值税计费">
                <template slot-scope="scope">
                  <div v-if="scope.row.addValueUpType == 1">按月累计</div>
                  <div v-if="scope.row.addValueUpType == 2">按季度累计</div>
                </template>
              </el-table-column>
              <el-table-column
              prop="signTime"
              label="签约时间">
              </el-table-column>
              <el-table-column
              prop="address"
              label="操作"
              width="130">
              <template slot-scope="scope">
                  <div><el-button @click="handleClick(scope.row)" size="mini" plain>修改签约</el-button></div>
              </template>
              </el-table-column>
          </el-table>
        </div>
        <pagination :total="total" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange"></pagination>
    </div>
    <!-- <div class="main signing" v-if="!userType">
      <div class="title">
        <div class="fanhui" @click="userType = true"><i class="el-icon-arrow-left"></i>返回</div>
        <div class="qianyue">用户签约</div>
      </div>
      <div class="header">
        <span>商户名称：{{userListObj.merchantName}}</span><span>个体工商户名称：{{userListObj.name}}</span><span>统一社会信用代码：{{userListObj.creditCode}}</span>
      </div>
      <div class="subtitle">普票设置</div>
      <div class="box">
        <div class="title">个税：</div>
        <div class="content">
          <div class="top">
            <div class="left">梯度</div>
            <div class="middle">梯度金额（元）</div>
            <div class="right">梯度税率（%）</div>
          </div>
          <div class="ladder" v-for="(item,key) in commonTaxLadder" :key="key">
            <div class="left">第{{chnNumChar[key]}}梯度</div>
            <div class="middle">
              <span><el-input v-model="item.minValue" placeholder="请输入金额"></el-input></span>
              <span><el-input v-model="item.maxValue" placeholder="请输入金额"></el-input></span>
            </div>
            <div class="right">
              <span><el-input v-model="item.rate" placeholder=""></el-input></span><i class="el-icon-close" @click="delGradient(key,'commonTaxLadder')"></i>
            </div>
          </div>
          <div class="bottom" @click="addGradient('commonTaxLadder')">添加梯度</div>
        </div>
      </div>
      <div class="box">
        <div class="title">增值税、附加税：</div>
        <div class="content">
          <div class="top">
            <div class="left">梯度</div>
            <div class="middle">梯度金额（元）</div>
            <div class="right">梯度税率（增值税/附加税）（%）</div>
          </div>
          <div class="ladder" v-for="(item,key) in commonOtherLadder" :key="key">
            <div class="left">第{{chnNumChar[key]}}梯度</div>
            <div class="middle">
              <span><el-input v-model="item.minValue" placeholder="请输入金额"></el-input></span>
              <span><el-input v-model="item.maxValue" placeholder="请输入金额"></el-input></span>
            </div>
            <div class="right">
              <span style="margin-right: 10px;"><el-input v-model="item.zengzhiRate" placeholder=""></el-input></span>
              <span><el-input v-model="item.fujiaRate" placeholder=""></el-input></span>
              <i style="right: 20px" class="el-icon-close" @click="delGradient(key,'commonOtherLadder')"></i>
            </div>
          </div>
          <div class="bottom" @click="addGradient('commonOtherLadder')">添加梯度</div>
        </div>
      </div>
      <div class="subtitle">专票设置</div>
      <div class="box">
        <div class="title">个税：</div>
        <div class="content">
          <div class="top">
            <div class="left">梯度</div>
            <div class="middle">梯度金额（元）</div>
            <div class="right">梯度税率（%）</div>
          </div>
          <div class="ladder" v-for="(item,key) in specialTaxLadder" :key="key">
            <div class="left">第{{chnNumChar[key]}}梯度</div>
            <div class="middle">
              <span><el-input v-model="item.minValue" placeholder="请输入金额"></el-input></span>
              <span><el-input v-model="item.maxValue" placeholder="请输入金额"></el-input></span>
            </div>
            <div class="right">
              <span><el-input v-model="item.rate" placeholder=""></el-input></span><i class="el-icon-close" @click="delGradient(key,'specialTaxLadder')"></i>
            </div>
          </div>
          <div class="bottom" @click="addGradient('specialTaxLadder')">添加梯度</div>
        </div>
      </div>
      <div class="box">
        <div class="title">增值税、附加税：</div>
        <div class="content">
          <div class="top">
            <div class="left">梯度</div>
            <div class="middle">梯度金额（元）</div>
            <div class="right">梯度税率（增值税/附加税）（%）</div>
          </div>
          <div class="ladder" v-for="(item,key) in specialOtherLadder" :key="key">
            <div class="left">第{{chnNumChar[key]}}梯度</div>
            <div class="middle">
              <span><el-input v-model="item.minValue" placeholder="请输入金额"></el-input></span>
              <span><el-input v-model="item.maxValue" placeholder="请输入金额"></el-input></span>
            </div>
            <div class="right">
              <span style="margin-right: 10px;"><el-input v-model="item.zengzhiRate" placeholder=""></el-input></span>
              <span><el-input v-model="item.fujiaRate" placeholder=""></el-input></span>
              <i style="right: 20px" class="el-icon-close" @click="delGradient(key,'commonOtherLadder')"></i>
            </div>
          </div>
          <div class="bottom" @click="addGradient('specialOtherLadder')">添加梯度</div>
        </div>
      </div>
    </div> -->
    <div class="main signing" v-if="!userType">
      <div class="title">
        <div class="fanhui" @click="userType = true"><i class="el-icon-arrow-left"></i>返回</div>
        <div class="qianyue">用户签约</div>
      </div>
      <div class="header">
        <div class="item">个体工商户名称：{{userListObj.name || ''}}</div>
        <div class="item">统一社会信用代码：{{userListObj.creditCode || ''}}</div>
        <div class="item">核定成本费用率（%）：<div style="width:233px"><el-input v-model="costRate" placeholder="请输入内容"></el-input></div></div>
        <div class="item">含税价百分比：<div style="width:233px"><el-input v-model="taxRate" placeholder="请输入内容"></el-input></div></div>
        <div class="item">个税计费模式：<div style="width:233px">
          <el-select v-model="taxUpType" style="width:100%" placeholder="请选择">
            <el-option
              v-for="item in taxUpOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select></div>
        </div>
        <div class="item">增值税计费模式：&#12288;&#12288;&#12288;<div style="width:233px">
          <el-select v-model="addValueUpType" style="width:100%" placeholder="请选择">
            <el-option
              v-for="item in addValueUpOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select></div>
        </div>
        <div class="item">服务费（%）：&#8197;<div style="width:233px"><el-input v-model="serviceRate" placeholder="请输入内容"></el-input></div></div>
        <div class="item" >发票内容：&#12288;&#12288;<div style="width:233px">
          <el-select v-model="invoicecontents" style="width:100%" multiple value-key="invoicecontent_id" placeholder="请选择" @change="invoiceChange">
            <el-option
              v-for="item in detailsOptions"
              :key="item.invoicecontent_id"
              :label="item.invoicecontentName"
              :value="item">
            </el-option>
          </el-select></div>
        </div><br/>
        <div class="item"><span>备注：&#12288;&#12288;&#12288;&#12288;</span><span style="width:760px"><el-input v-model="signNotes" type="textarea" :rows="4" resize="none" placeholder="请输入内容"></el-input></span></div>
      </div>
      <div class="subtitle">普票设置</div>
      <div class="box">
        <div class="title">个税：</div>
        <div class="content">
          <div class="top">
            <div class="left">梯度</div>
            <div class="middle">梯度金额（元）</div>
            <div class="right">梯度税率（%）</div>
            <div class="right">速扣金额（元）</div>
          </div>
          <div class="ladder" v-for="(item,key) in commonTaxLadder" :key="key">
            <div class="left">第{{chnNumChar[key]}}梯度</div>
            <div class="middle">
              <span><el-input v-model="item.minValue" placeholder="请输入金额"></el-input></span>
              <span><el-input v-model="item.maxValue" placeholder="请输入金额"></el-input></span>
            </div>
            <div class="right">
              <span><el-input v-model="item.rate" placeholder=""></el-input></span>
            </div>
            <div class="right">
              <span><el-input v-model="item.quiCalDed" placeholder=""></el-input></span>
            </div>
            <i class="el-icon-close" @click="delGradient(key,'commonTaxLadder')"></i>
          </div>
          <div class="bottom" @click="addGradient('commonTaxLadder')">添加梯度</div>
        </div>
      </div>
      <div class="box">
        <div class="title">增值税、附加税：</div>
        <div class="content">
          <div class="top">
            <div class="left">梯度</div>
            <div class="middle">梯度金额（元）</div>
            <div class="right">增值税税率（%）</div>
            <div class="right">附加税税率（%）</div>
          </div>
          <div class="ladder" v-for="(item,key) in commonOtherLadder" :key="key">
            <div class="left">第{{chnNumChar[key]}}梯度</div>
            <div class="middle">
              <span><el-input v-model="item.minValue" placeholder="请输入金额"></el-input></span>
              <span><el-input v-model="item.maxValue" placeholder="请输入金额"></el-input></span>
            </div>
            <div class="right">
              <span><el-input v-model="item.zengzhiRate" placeholder=""></el-input></span>
            </div>
            <div class="right">
              <span><el-input v-model="item.fujiaRate" placeholder=""></el-input></span>
            </div>
            <i class="el-icon-close" @click="delGradient(key,'commonOtherLadder')"></i>
          </div>
          <div class="bottom" @click="addGradient('commonOtherLadder')">添加梯度</div>
        </div>
      </div>
      <div class="subtitle">专票设置</div>
      <div class="box">
        <div class="title">个税：</div>
        <div class="content">
          <div class="top">
            <div class="left">梯度</div>
            <div class="middle">梯度金额（元）</div>
            <div class="right">梯度税率（%）</div>
            <div class="right">速扣金额（元）</div>
          </div>
          <div class="ladder" v-for="(item,key) in specialTaxLadder" :key="key">
            <div class="left">第{{chnNumChar[key]}}梯度</div>
            <div class="middle">
              <span><el-input v-model="item.minValue" placeholder="请输入金额"></el-input></span>
              <span><el-input v-model="item.maxValue" placeholder="请输入金额"></el-input></span>
            </div>
            <div class="right">
              <span><el-input v-model="item.rate" placeholder=""></el-input></span>
            </div>
            <div class="right">
              <span><el-input v-model="item.quiCalDed" placeholder=""></el-input></span>
            </div>
            <i class="el-icon-close" @click="delGradient(key,'specialTaxLadder')"></i>
          </div>
          <div class="bottom" @click="addGradient('specialTaxLadder')">添加梯度</div>
        </div>
      </div>
      <div class="box">
        <div class="title">增值税、附加税：</div>
        <div class="content">
          <div class="top">
            <div class="left">梯度</div>
            <div class="middle">梯度金额（元）</div>
            <div class="right">增值税税率（%）</div>
            <div class="right">附加税税率（%）</div>
          </div>
          <div class="ladder" v-for="(item,key) in specialOtherLadder" :key="key">
            <div class="left">第{{chnNumChar[key]}}梯度</div>
            <div class="middle">
              <span><el-input v-model="item.minValue" placeholder="请输入金额"></el-input></span>
              <span><el-input v-model="item.maxValue" placeholder="请输入金额"></el-input></span>
            </div>
            <div class="right">
              <span><el-input v-model="item.zengzhiRate" placeholder=""></el-input></span>
            </div>
            <div class="right">
              <span><el-input v-model="item.fujiaRate" placeholder=""></el-input></span>
            </div>
            <i class="el-icon-close" @click="delGradient(key,'commonOtherLadder')"></i>
          </div>
          <div class="bottom" @click="addGradient('specialOtherLadder')">添加梯度</div>
        </div>
      </div>
      <div style="width: 100%;text-align: center;">
        <el-button type="primary" @click="signingConfirm">修改</el-button>
        <el-button @click="userType = false">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api/api.js'
import {get, post} from '@/api/index.js'
import pagination from '@/components/pagination'
export default {
  data() {
    return {
      companyValue:'',
      total: null,
      pageSzie: 10,
      signingData: [],
      userType: true,
      userListObj: {},
      CompanyOptions: [],
      chnNumChar: ["一","二","三","四","五","六","七","八","九"],
      detailsOptions: [],
      invoicecontents:[
        // {
        //   invoicecontent_id: "1",    // 开票内容id
        //   invoicecontentName: "xx"  // 开票内容名称
        // }
      ],
      taxUpType: '',
      addValueUpType: '',
      costRate: '',
      taxRate: '',
      serviceRate: '',
      signNotes: '',
      commonTaxLadder: [
        {
          minValue: '',
          maxValue: '',
          quiCalDed: '',
          rate: ''
        }
      ],
      commonOtherLadder: [
        {
          minValue: '',
          zengzhiRate: "",
          fujiaRate: "",
          maxValue: ''
        }
      ],
      specialTaxLadder: [
        {
          minValue: '',
          maxValue: '',
          quiCalDed: '',
          rate: ''
        }
      ],
      specialOtherLadder: [
        {
          minValue: '',
          zengzhiRate: "",
          fujiaRate: "",
          maxValue: ''
        }
      ],
      taxUpOptions:[
        {
          value: '1',
          label: '按年累计'
        },
        {
          value: '2',
          label: '按月累计'
        }
      ],
      addValueUpOptions:[
        {
          value: '1',
          label: '按月累计'
        },
        {
          value: '2',
          label: '按季度累计'
        }
      ],
    }
  },
  mounted() {
    // this.CompanyOptions = JSON.parse(localStorage.getItem('nameList')) || []
    this.signNamesPost()
    this.signListPost()
    this.invoiceContentPost()
  },
  methods: {
    // 发票多选事件
    invoiceChange(rows) {
      console.log(rows)
    },
    // 
    signNamesPost() {
      post(api.signNames)
      .then((d) => {
        if (d.status === 0) {
          console.log(d,'??????????????')
          this.CompanyOptions = []
          for (let i = 0; i < d.data.length; i++) {
            var obj = {
              value : d.data[i].id,
              label : d.data[i].name
            }
            this.CompanyOptions.push(obj)
          }
        }
      }, (err) => {
          //error callback
      })
    },
    // 发票内容列表
    invoiceContentPost() {
      post(api.invoiceContentList, {
        currentPage: 1, //非必传
        pageSize: 1000 //非必传
      })
      .then((d) => {
        this.detailsOptions = []
        for (let i = 0; i < d.rows.length; i++) {
          var obj = {
            invoicecontent_id : d.rows[i].id,
            invoicecontentName : d.rows[i].name
          }
          this.detailsOptions.push(obj)
        }
        console.log(d,'####################')
      }, (err) => {
        console,log(err.msg)
        //error callback
      })
    },
    // 删除梯度
    delGradient(key,dome) {
      if (this[dome].length == 1) {
        this.$message({
          showClose: true,
          message: '至少保留一条',
          type: 'warning'
        });
        return 
      }
      this.$confirm('确定删除第' + this.chnNumChar[key] + '梯队？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this[dome].splice(key,1)
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });          
      });
    },
    // 添加梯度
    addGradient(dome) {
      var obj = {
        minValue: '',
        maxValue: '',
        rate: ''
      }
      if ( this[dome].length < 5 ) {
        this[dome].push(obj)
      }else {
        this.$message({
          showClose: true,
          message: '最多添加五条',
          type: 'warning'
        });
      }
    },
    handleSizeChange(val) {
      this.pageSzie = val
      console.log(`每页 ${val} 条aaaaa`);
      this.signListPost()
    },
    handleCurrentChange(size) {
      console.log(size)
      this.signListPost(size)
    },
    search() {
      this.signListPost()
    },
    reset() {
      this.companyValue = ''
      this.signListPost()
    },
    signListPost(size) {
      post(api.signPage, {
        currentPage: size || 1,
        pageSize: this.pageSzie,
        businessmenId: this.companyValue
      })
      .then((d) => {
        console.log(d.status)
        if (d.status === 0) {
          this.signingData = d.data.rows
          // this.signingData = []
          // console.log(d,'!!!!!!!!!!!!')
          this.total = d.data.count
          // for (let i = 0; i < d.data.rows.length; i++) {
          //   d.data.rows[i].merchantSign['name'] = d.data.rows[i].merchant.name
          //   this.signingData.push(d.data.rows[i].merchantSign)
          // }
        }
      }, (err) => {
          //error callback
      })
    },
    // 修改签约
    handleClick(row) {
      console.log(row);
      this.userType = false
      this.userListObj = row
      this.taxUpType = row.taxUpType
      this.addValueUpType = row.addValueUpType
      this.costRate = row.costRate
      this.taxRate = row.taxRate
      this.serviceRate = row.serviceRate
      this.signNotes = row.signNotes
      this.commonTaxLadder = row.commonTaxLadder
      this.commonOtherLadder = row.commonOtherLadder
      this.specialTaxLadder = row.specialTaxLadder
      this.specialOtherLadder = row.specialOtherLadder
      this.invoicecontents = row.invoicecontents
    },
    signingConfirm() {
      post(api.sohoSign, {
        id: this.userListObj.id,
        taxUpType: this.taxUpType,
        addValueUpType: this.addValueUpType,
        costRate: this.costRate,
        taxRate : this.taxRate,
        serviceRate : this.serviceRate,
        signNotes: this.signNotes,
        commonTaxLadder: this.commonTaxLadder,
        commonOtherLadder: this.commonOtherLadder,
        specialTaxLadder: this.specialTaxLadder,
        specialOtherLadder: this.specialOtherLadder,
        invoicecontents: this.invoicecontents
      })
      .then((d) => {
        if (d.status === 0) {
          console.log(d,'!!!!!!!!!!!!')
          this.userType = true
          this.signListPost()
        }else {
          console.log(d.msg)
        }
      }, (err) => {
        console.log(err.msg)
          //error callback
      })
    }
  },
  components: {
    pagination: pagination
  }
}
</script>

<style lang="less" scoped>
.usersSignUp {
    width: 100%;
    padding: 22px 20px;
    box-sizing: border-box;
    overflow-y: auto;
    .main {
        width: 100%;
        height: 100%;
        background-color: #fff;
        padding: 20px;
        box-sizing: border-box;
        .top-search {
            width: 100%;
            height: 52px;
            line-height: 52px;
            margin-bottom: 10px;
            .search-item {
                float: left;
                margin-right: 20px;
                font-size:14px;
                font-family:PingFangSC;
                font-weight:400;
                color:rgba(51,51,51,1);
                div {
                    display: inline-block;
                    width: 250px;
                }
            }
        }
        .middle-button {
            width: 100%;
            text-align: left;
            padding-top: 10px;
        }
        .bottom-table {
            width: 100%;
            margin-top: 20px;
        }
        .bottom-pag {
            width: 100%;
            margin-top: 20px;
        }
    }
    .signing {
      min-width: 1300px;
      .title {
        width: 100%;
        height: 52px;
        line-height: 52px;
        .fanhui {
          float: left;
          font-size:14px;
          font-family:PingFangSC;
          font-weight:400;
          color:rgba(102,102,102,1);
          position: relative;
          cursor: pointer;
        }
        .fanhui:after {
          content: '';
          position: absolute;
          top: 20px;
          right: -16px;
          width: 1px;
          height: 13px;
          background-color: #979797;
        }
        .qianyue {
          float: left;
          margin-left: 24px;
          font-size:14px;
          font-family:PingFangSC;
          font-weight:600;
          color:rgba(51,51,51,1);
        }
      }
      .header {
        width: 100%;
        // height:75px;
        // background:rgba(242,242,242,0.8);
        border-radius:6px;  
        padding: 28px 27px;
        box-sizing: border-box;
        text-align: left;
        margin-top: 10px;
        .item {
          min-width: 33%;
          display: inline-block;
          line-height: 40px;
          font-size:14px;
          font-family:PingFangSC;
          font-weight:400;
          color:rgba(51,51,51,1);
          // margin-right: 55px;
          margin-bottom: 15px;
          div {
            display: inline-block;
          }
          span {
            float: left;
          }
        }
        // span {
        //   display: inline-block;
        //   font-size:14px;
        //   font-family:PingFangSC;
        //   font-weight:400;
        //   color:rgba(51,51,51,1);
        //   margin-right: 55px;
        // }
      }
      .subtitle {
        width: 100%;
        height:53px;
        background:rgba(180,220,255,0.3);
        border-radius:4px;
        line-height: 53px;
        text-align: left;
        font-size:14px;
        font-family:PingFangSC;
        font-weight:400;
        color:rgba(51,51,51,1);
        margin-top: 20px;
        padding-left: 27px;
        box-sizing: border-box;
      }
      .box {
        margin-top: 20px;
        width: 100%;
        // min-height:361px;
        padding-bottom: 20px;
        border-radius:6px;
        border:1px solid rgba(195,195,195,0.8);
        .title {
          width: 100%;
          height: 51px;
          font-size:14px;
          font-family:PingFangSC;
          font-weight:400;
          color:rgba(51,51,51,1);
          padding-left: 27px;
          box-sizing: border-box;
          line-height: 51px;
          text-align: left;
        }
        .content {
          width: 1200px;
          height: auto;
          margin: 0 auto;
          margin-top: 20px;
          div {
            width: 100%;
            padding-right: 10px;
            box-sizing: border-box;
            overflow: hidden;
            position: relative;
            .middle {
              width: 40%;
              height: 100%;
              float: left;
              span {
                display: inline-block;
                width: 210px;
                height: 100%;
                margin-right: 20px;
              }
            }
            .left {
              width: 20%;
              height: 100%;
              float: left;
            }
            .right {
              width: 20%;
              height: 100%;
              float: right;
              span {
                display: inline-block;
                // width:84px;
                height: 100%;
              }
              i:hover {
                color: #409EFF
              }
            }
            i {
              position: absolute;
              right: 10px;
              top: 18px;
              color: #C3C3C3;
              font-size: 18px;
              cursor: pointer;
            }
          }
          .ladder {
            width: 100%;
            height: 56px;
            line-height: 56px;
          }
          .top {
            width: 100%;
            height: 46px;
            line-height: 46px;
            background:rgba(240,240,240,1);
            font-size:14px;
            font-family:PingFangSC;
            font-weight:400;
            color:rgba(70,92,109,1);
          }
          .bottom {
            width: 100%;
            height:46px;
            line-height: 46px;
            text-align: center;
            background:rgba(232,244,255,1);
            border:1px solid rgba(193,225,255,1);
            font-size:14px;
            font-family:PingFangSC;
            font-weight:400;
            color:rgba(40,152,255,1);
            cursor: pointer;
          }
        }
      }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/trading/soho/usersSignUp.vue